import { InviteFormStrategy } from '../invite-form.interface';

export class InviteProjectMemberStrategy implements InviteFormStrategy {
  readonly header = 'invite-form.project.invite-members';
  readonly description = 'invite-form.project.you-can-add-multiple-addresses-separate-them-with-a';
  readonly emailPlaceholder = 'invite-form.project.enter-email-addresses';
  readonly inviteButtonLabel = 'invite-form.project.buttons.invite-to-project';
  readonly cancelButtonLabel = 'invite-form.project.buttons.cancel';
}
